import { render, staticRenderFns } from "./FrsCropUsagePicker.vue?vue&type=template&id=0b988b20&scoped=true&lang=html&"
import script from "./FrsCropUsagePicker.vue?vue&type=script&lang=js&"
export * from "./FrsCropUsagePicker.vue?vue&type=script&lang=js&"
import style0 from "./FrsCropUsagePicker.vue?vue&type=style&index=0&id=0b988b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b988b20",
  null
  
)

export default component.exports